import { render, staticRenderFns } from "./ChildrenorgManagement.vue?vue&type=template&id=55ca603e&scoped=true&"
import script from "./ChildrenorgManagement.vue?vue&type=script&lang=js&"
export * from "./ChildrenorgManagement.vue?vue&type=script&lang=js&"
import style0 from "./ChildrenorgManagement.vue?vue&type=style&index=0&id=55ca603e&lang=scss&scoped=true&"
import style1 from "./ChildrenorgManagement.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ca603e",
  null
  
)

export default component.exports